import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import colors from '../../../config/colors.json';

export const TitleHeader = styled.div`
  background-color: ${({ backgroundColor }) => (backgroundColor || colors.light)};
  padding: ${({ padding }) => (padding || '18px 35px')};
  margin: ${({ margin }) => (margin)};
`;

export const Exit = styled(NavLink)`
  color: ${colors.lightGrey5};
  font-size: 30px;
  float: right;
  :hover {
      color: ${colors.lightGrey5};
      text-decoration: none;
  }
`;

export const HeaderBody = styled.div`
  color: ${colors.lightGreyMidias};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SingleLinkContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.greyMidias};
  margin-right: 32px;
`;

export const StyledLink = styled(NavLink)`
  color: ${colors.greyMidias};
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  padding: 5px;
  text-decoration: none;
  &:hover {
    text-decoration: none;
    color: ${colors.greyMidias};
    opacity: 0.6;
  }
  &.is-active {
    border-bottom: 3px solid red;
    color: ${colors.darkGreyMidias};
    transition: border 0.6s linear;
  }
`;
